// extracted by mini-css-extract-plugin
export const scope = "styles-module--scope--RkhNV";
export const scope0 = "styles-module--scope0--A1Pvy";
export const scope1 = "styles-module--scope1--2Hhkf";
export const scope2 = "styles-module--scope2--3_ZWm";
export const scope3 = "styles-module--scope3--3PQ1K";
export const scope4 = "styles-module--scope4--3IWGr";
export const scope5 = "styles-module--scope5--1s7nd";
export const scope6 = "styles-module--scope6--3ARLk";
export const scope7 = "styles-module--scope7--2as4J";